import Entity from '../entity'

export default class ExchangeRate extends Entity<number>{
    currency_id: number;
    rate: number;
    process_date: string;
}


